import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import { LinearProgressBar } from "../../shared";
import {sampleFilterFual} from  "./ReportObj";
import {sampleFilterLube} from "./ReportObj";
import {sampleFilterTOT} from "./ReportObj";
import { FilterComponentObj } from "../FilterComponents/FilterComponentObj";
import { getCurrentDate, getCurrentDateOfBelow, getDefaultFuelDate, getDefaultLubeDate, getDefaultTotDate } from "../../services/DateServices";
import { datePickerDefaultProps } from "@material-ui/pickers/constants/prop-types";

export default function  (props) {
  //////
  const history = useHistory();
  const { row, type,filterSampleFuel,filterSampleLube,filterSampleTot,tabName,isEmpty,tab,reportsubType,barData,Resetclearprogressbar} = props;
  console.log("ReportSubtype",reportsubType);
  ////
  let FormData = props.formObj
  let linearData=[];

  let max=0;
  if(row.typeOfCase)
  {
    row.typeOfCase.forEach((item)=>{
      max=item.value > max ? item.value:max;
    });
    row.typeOfCase.forEach((item)=>{
      ////
      let data={...item};
      data.perValue=(item.value>0?(item.value/(max)) * 100:0);
      linearData.push(data);
    });
}

  const useStyles = makeStyles((theme) => ({
    mainBox: {},
    roundBox: {
      borderRadius: "50%",
      border: "6px solid #1a1a31",
      height: "130px",
      width: "130px",
      minWidth: "130px",
      textAlign: "center",
    },
  }));

  function onReportDetails(data, type) {
    history.push({
      pathname: "/dashboard/reports",
      data: data,
      type:type,
      subType: ""
    });
  }
  
  const classes = useStyles();
  //const [formObj, setFormObj] = useState({...sampleFilterFual,...sampleFilterLube,...sampleFilterTOT});
  const [formObj, setFormObj] = useState(FilterComponentObj);
  const [filtercomObj, setfiltercomObj] = React.useState(FilterComponentObj);
  const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
  const [boxingshadow, setboxingshadow] = React.useState("");
  const [selected, setSelected]=React.useState("")

  const onChangeText = (event) => {
    //
    //setSelected(event.title)
    //let Obj={ ...formObj,Totsamplestatus:event.title/* , statusType: event.title, sampledFromDate :FormData.sampledFromDate,sampledToDate:FormData.sampledToDate */ }
   let Obj={};
    let Obj_1={};
   let Obj_2={};
   let Obj_3={};

   
   if (reportsubType=="Fuel"){
    setSelected(event.title)
     Obj_1=[{id:event.title,name:event.title}]
     Obj.Fqtsampleenddate=[getDefaultFuelDate().endDate];
    Obj.Fqtsamplestartdate=[getDefaultFuelDate().startDate];
   filterSampleFuel({...filtercomObj,Fqtsampleenddate:Obj.Fqtsampleenddate,Fqtsamplestartdate:Obj.Fqtsamplestartdate,...barData,Fqtsamplestatus:Obj_1})
   Resetclearprogressbar()
  }else if (reportsubType=="Lube"){
    //defaultValue()
    setSelected(event.title)
    Obj_2=[{id:event.title,name:event.title}]
    Obj.lubesampleenddate=[getDefaultLubeDate().endDate];
        Obj.lubesamplestartdate=[getDefaultLubeDate().startDate];
   filterSampleLube({...filtercomObj,lubesamplestartdate:Obj.lubesamplestartdate,lubesampleenddate:Obj.lubesampleenddate,...barData,lubesamplestatus:Obj_2})
   Resetclearprogressbar()
  }else{
    //defaultValue()
    setSelected(event.title)
    Obj_3=[{id:event.title,name:event.title}]
    Obj.Totsampleenddate =[getDefaultTotDate().endDate];
          Obj.Totsamplestartdate=[getDefaultTotDate().startDate];
    filterSampleTot({...filtercomObj,Totsamplestartdate:Obj.Totsamplestartdate,Totsampleenddate:Obj.Totsampleenddate,...barData,Totsamplestatus:Obj_3,})
    Resetclearprogressbar()
  }
  
  };
  const defaultValue = (val) => {
    
    let Obj={};
    if (val !== "" && val !== undefined && val !== "null") {
         Obj = JSON.parse(val);
         if (reportsubType=="Fuel" || tabName=="Fuel"){
          Obj.Fqtsampleenddate=[getDefaultFuelDate().endDate];
        Obj.Fqtsamplestartdate=[getDefaultFuelDate().startDate];
         }

        else if (reportsubType=="Lube"  || tabName=="Lube"){
        Obj.lubesampleenddate=[getDefaultLubeDate().endDate];
        Obj.lubesamplestartdate=[getDefaultLubeDate().startDate];
         }
         else {
          Obj.Totsampleenddate =[getDefaultTotDate().endDate];
          Obj.Totsamplestartdate=[getDefaultTotDate().startDate];
         }
    }
    else
    {
      if (reportsubType=="Fuel"|| tabName=="Fuel"){
        Obj.Fqtsampleenddate=[getDefaultFuelDate().endDate];
        Obj.Fqtsamplestartdate=[getDefaultFuelDate().startDate];
       }

      else if (reportsubType=="Lube"|| tabName=="Lube"){
      Obj.lubesampleenddate=[getDefaultLubeDate().endDate];
      Obj.lubesamplestartdate=[getDefaultLubeDate().startDate];
       }
       else {
        Obj.Totsampleenddate =[getDefaultTotDate().endDate];
        Obj.Totsamplestartdate=[getDefaultTotDate().startDate];
       }
    }
    setfiltercomObj(Obj);
}
  useEffect(() => {
    defaultValue(GlobalFilterSettingValue);
  }, []);
  useEffect(() => {
    //
    if (props.ClearProgressBar == true){
      setSelected(props.DataProgressBar)
    }
  }, [props.ClearProgressBar,props.DataProgressBar]);
  
  useEffect(() => {
    //
    let SelectedReports = ""
    if (reportsubType == "Fuel") {
      let ObjParse = JSON.parse(GlobalFilterSettingValue);
      if (ObjParse !== "" && ObjParse !== undefined && ObjParse) {
      SelectedReports = ObjParse.Fqtsamplestatus[0] ? ObjParse.Fqtsamplestatus[0].name : null
      setSelected(SelectedReports)
      }
    }
  }, [GlobalFilterSettingValue, tabName])
  useEffect(() => {
    //
    let SelectedReports = ""
    if (reportsubType == "Tot") {
      let ObjParse_2 = JSON.parse(GlobalFilterSettingValue);
      if (ObjParse_2 !== "" && ObjParse_2 !== undefined && ObjParse_2) {
      SelectedReports = ObjParse_2.Totsamplestatus[0] ? ObjParse_2.Totsamplestatus[0].name : null
      setSelected(SelectedReports)
    }
  }
  }, [GlobalFilterSettingValue, tabName])
  useEffect(() => {
    //
    let SelectedReports = ""
    if (reportsubType == "Lube") {
      let ObjParse_1 = JSON.parse(GlobalFilterSettingValue);
      if (ObjParse_1 !== "" && ObjParse_1 !== undefined && ObjParse_1) {
      SelectedReports = ObjParse_1.lubesamplestatus[0] ? ObjParse_1.lubesamplestatus[0].name : null
      setSelected(SelectedReports)
    }
  }

  }, [GlobalFilterSettingValue, tabName])
  /* useEffect(()=>{
    setSelected("");
  },[isEmpty])
  useEffect(()=>{
    setSelected("");
  },[tab]) */
  return (
    <div>
      <Box
        component="main"
        bgcolor="#fff"
        p={2}
        className={classes.mainBox}
        display="flex"
      >
        <Grid container>
          <Grid item xs={12}>
            <Box component="h4" className="dashboard-sub-title" pb={0} fontSize={16} m={0}>
              <Box component="div" display="flex" alignItems="center">
              <Grid container>
                <Grid item xs={12} sm={12} md={6}> 
                <Box component="span" pr={0.5} pt={0.5}>
                  {type=="reportstatus"? <img src="assets/svg/Reports1.png" /> : <img src="/assets/svg/flask.svg" />}
                </Box>
                <Box component="span" className="titlecopy1" > {row.title}  </Box>
                </Grid>
                {/* <Grid item xs={12} sm={12} md={6} className="text-right"> 
                <Box component="span" className="thidays"> *Data displayed for last 30 days</Box>
                </Grid> */}
                </Grid>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box component="div" py={2}>
              <Grid container>
                <Grid item xs={12} sm={12} md={5} >
                  <Box
                    component="div"
                    display="flex"
                    pr={2}
                    justifyContent="right"
                  >
                    <Box
                      component="div"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      className={classes.roundBox}
                    >
                      <Box component="div" className="dash-left-cir">
                        <Box
                          component="h2"
                  
                        >
                          {row.caseCount}
                        </Box>
                        <Box component="span" fontSize={14}>
                          {row.text1} {row.text2}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={7} >
                  {Object.keys(row).length
                    ? linearData.map((item) => (
                        <Box component="div" key={item.title} pb={1} pt={0.8} 
                          style={{cursor:"pointer",padding:"5px","box-shadow":selected===item.title && props.clearBarSelection==false?"0 0 11px":null}}
                            class="progressBar"
                            onClick={()=>{onChangeText(item)}}  >
                          <LinearProgressBar
                            colors={item.color}
                            value={item.perValue}
                            numbers={item.value}
                            boxShadow={item.boxShadow}                             
                          />
                        </Box>
                      ))
                    : ""}
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box component="div" display="flex" alignItems="center">
              {Object.keys(row).length
                ? row.typeOfCase.map((item) => (
                  
                  <Box className="dashboardkey"
                      key={item.title}
                      component="div"
                      pr={2}
                    >
                      <svg height="10" width="10">
                        <circle cx="5" cy="5" r="4" fill={item.color} />
                      </svg>
                      <Box component="span" pl={1}>
                        {item.title}
                      </Box>
                    </Box>
                   
                  ))
                : ""}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
